import { Outlet, useLocation, useNavigate } from "react-router-dom";
// @polaris
import { Box, Button, Page } from "@shopify/polaris";
// components
import TitleBar from "./TitleBar";
// constants
import { APP_ROUTES, DATABASE_STATUTES, PRODUCT_TYPE } from "../../common/constants";
// hooks
import useLocales from "../../hooks/useLocales";
import useProductsContext from "../../hooks/useProductsContext";

const AddProductLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  const { statuses, selectedItems, selectedItemsType, saveSelectedProducts } = useProductsContext();

  const { translate } = useLocales();

  const handleNextAdd = () => {
    navigate(APP_ROUTES.PRODUCTS.ADD.PREORDERS, {
      state: { ...state, type: selectedItemsType, mode: "add", ids: selectedItems },
    });

    saveSelectedProducts({ ids: [], type: PRODUCT_TYPE });
  };

  const isEditMode = state && state.mode === "edit";
  const isAddProductsMode = location.pathname.includes(APP_ROUTES.PRODUCTS.ADD.PREORDERS);

  const header = isAddProductsMode
    ? translate("tobetranslated.product.sub.config")
    : isEditMode
      ? translate("nav.sub.update-products")
      : translate("nav.sub.add-products");

  const breadcrumb =
    isAddProductsMode && !isEditMode
      ? {
          name: translate("nav.sub.add-products"),
          href: APP_ROUTES.PRODUCTS.ADD.ROOT,
        }
      : {
          name: translate("nav.sub.products"),
          href: APP_ROUTES.PRODUCTS.PREORDERS,
        };

  const action = !isAddProductsMode ? (
    <Button
      variant="primary"
      onClick={handleNextAdd}
      disabled={!selectedItems.length || statuses.loadProducts === DATABASE_STATUTES.LOADING}
    >
      Proceed
    </Button>
  ) : null;

  return (
    <Page fullWidth={!isAddProductsMode}>
      <Box paddingInline={{ xs: "400", sm: "0" }}>
        <TitleBar heading={header} breadcrumb={breadcrumb} action={action} />

        <Outlet />
      </Box>
    </Page>
  );
};

export default AddProductLayout;
